import { format, addDays, getDay, startOfDay } from "date-fns";

const VN_DAY_NAMES = [
  "Chủ nhật",
  "Thứ 2",
  "Thứ 3",
  "Thứ 4",
  "Thứ 5",
  "Thứ 6",
  "Thứ 7",
] as const;
const VN_DAY_SHORT = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"] as const;

/** Vietnamese dong, no decimals: 1.500.000 ₫ */
export function formatVND(value: number): string {
  return new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    maximumFractionDigits: 0,
  }).format(value);
}

/** dd/MM/yyyy */
export function formatDate(iso: string | Date): string {
  return format(typeof iso === "string" ? new Date(iso) : iso, "dd/MM/yyyy");
}

/** Returns the most recent Monday (or today if today is Monday) at 00:00. */
export function getCurrentOrLastMonday(now: Date = new Date()): Date {
  const day = getDay(now);
  const daysBack = day === 0 ? 6 : day - 1;
  return startOfDay(addDays(now, -daysBack));
}

export function formatWeekId(monday: Date): string {
  return format(monday, "yyyy-MM-dd");
}

/** Inverse of formatWeekId: a yyyy-MM-dd Monday id -> local Date at 00:00. */
export function parseWeekId(weekId: string): Date {
  return startOfDay(new Date(`${weekId}T00:00:00`));
}

export function formatWeekLabel(monday: Date): string {
  const sunday = addDays(monday, 6);
  return `${format(monday, "dd/MM")} – ${format(sunday, "dd/MM")}`;
}

export function getWeekDates(monday: Date): string[] {
  return Array.from({ length: 7 }, (_, i) => format(addDays(monday, i), "yyyy-MM-dd"));
}

export function formatDayHeader(monday: Date, offset: number): string {
  const date = addDays(monday, offset);
  return `📅 ${VN_DAY_NAMES[getDay(date)]} — ${format(date, "dd/MM")}`;
}

export function getShortDayName(monday: Date, offset: number): string {
  return VN_DAY_SHORT[getDay(addDays(monday, offset))];
}

export function formatHours(totalHours: number): string {
  return `${totalHours} giờ`;
}
